import { jsx as _jsx } from "react/jsx-runtime";
import { Field, useFormikContext } from "formik";
import { UppercaseTextField } from "@ploy-ui/form-fields";
import { useIntl } from "react-intl";
import { messages } from "../messages";
import { isRegistrationNumberValid } from "../helpers";
export const RegistrationNumberField = ({ onGetContract, contractIsLoading, onResetForm }) => {
    const intl = useIntl();
    const { values, isSubmitting, setFieldValue, setFieldTouched } = useFormikContext();
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            if (!isRegistrationNumberValid(values.registrationNumber)) {
                setFieldTouched("registrationNumber", true);
                return;
            }
            if (onResetForm) {
                onResetForm();
            }
            setFieldValue("buyoutDate", "");
            setFieldValue("mileage", undefined);
            onGetContract(values.registrationNumber.trim());
        }
    };
    return (_jsx(Field, { name: "registrationNumber", label: intl.formatMessage(messages.registrationNumber), variant: "outlined", component: UppercaseTextField, disabled: contractIsLoading || isSubmitting, fullWidth: true, InputLabelProps: { shrink: true }, autoFocus: true, onKeyDown: handleKeyDown }));
};
//# sourceMappingURL=RegistrationNumberField.js.map